import React from "react";

const OverviewSkeleton = () => {
  return (
    <div className="flex flex-col gap-8 animate-pulse">
      {/* Welcome Section */}
      <div className="h-40 bg-gray-200 rounded-3xl p-8 border border-white/20"></div>

      {/* Content Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 min-h-[500px]">
        {/* Left Column - Timing Skeleton */}
        <div className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 h-full">
          <div className="flex justify-between mb-8">
            <div className="h-6 w-32 bg-gray-200 rounded"></div>
            <div className="h-12 w-12 bg-gray-200 rounded-2xl"></div>
          </div>
          <div className="text-center mb-8">
            <div className="h-16 w-48 bg-gray-200 rounded mx-auto mb-3"></div>
            <div className="h-4 w-24 bg-gray-200 rounded mx-auto"></div>
          </div>
          <div className="grid grid-cols-2 gap-4 mb-8">
            <div className="bg-gray-50 rounded-2xl p-4 h-24"></div>
            <div className="bg-gray-50 rounded-2xl p-4 h-24"></div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="h-14 bg-gray-200 rounded-2xl"></div>
            <div className="h-14 bg-gray-200 rounded-2xl"></div>
          </div>
        </div>

        {/* Right Column - Activity Log Skeleton */}
        <div className="bg-white rounded-3xl p-8 shadow-sm border border-gray-100 h-full flex flex-col">
          <div className="flex justify-between mb-8">
            <div className="h-6 w-48 bg-gray-200 rounded"></div>
            <div className="h-4 w-16 bg-gray-200 rounded"></div>
          </div>
          <div className="flex-1 space-y-6">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex gap-4">
                <div className="h-14 w-14 bg-gray-200 rounded-2xl flex-shrink-0"></div>
                <div className="flex-1 space-y-2">
                  <div className="flex justify-between">
                    <div className="h-4 w-32 bg-gray-200 rounded"></div>
                    <div className="h-4 w-16 bg-gray-200 rounded"></div>
                  </div>
                  <div className="h-3 w-20 bg-gray-200 rounded"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewSkeleton;
